import { Instant, LocalDate } from './datetime';
export const parseInstantN = (x) => (x ? Instant.parse(x) : null);
export const parseInstant = (x) => Instant.parse(x);
export const parseLocalDateN = (x) => (x ? LocalDate.parse(x) : null);
export const parseLocalDate = (x) => LocalDate.parse(x);
